import { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router'
import { Box } from '@mui/material'
import { Skeleton } from '@mui/material'
import * as Sentry from '@sentry/react'
import { AppRoutes } from './app-routes'
import LoginRedirect from './components/Login/LoginRedirect'

const PublicLayout = lazy(() => import('./Layouts/PublicLayout'))
const MainLayout = lazy(() => import('./Layouts/MainLayout'))
const Register = lazy(() => import('./components/Register/Register'))
const Forgot = lazy(() => import('./components/Login/Forgot'))
const Login = lazy(() => import('./components/Login/Login'))
// todo: remove redux
// @ts-ignore
const VerifyLogin = lazy(() => import('./components/Login/VerifyLogin'))
const Personvaern = lazy(() => import('./components/Navigation/Personvaern'))
const PageNotFound = lazy(() => import('./components/Navigation/PageNotFound/PageNotFound'))
const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes)

export const MainRouter = () => {
  return (
    <Suspense
      fallback={
        <Box pt={0.5}>
          <Skeleton />
          <Skeleton width="60%" />
        </Box>
      }
    >
      <SentryRoutes>
        <Route path="/personvaern" element={<Personvaern />} />
        <Route path="/login" element={<Login />} />
        <Route path="/login/verify/:token/" element={VerifyLogin} />
        <Route path="/register/:token/" element={<Register />} />
        <Route path="/forgot" element={<Forgot />} />
        <Route path="/login-redirect" element={<LoginRedirect />} />
        <Route path="/forgot/:token/" element={<Forgot />} />
        <Route path="/public/*" element={<PublicLayout />} />
        <Route path={AppRoutes.NOT_FOUND} element={<PageNotFound />} />

        <Route path="*" element={<MainLayout />} />
      </SentryRoutes>
    </Suspense>
  )
}
